import { useCallback } from 'react'

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function useFunction<T extends Function>(fn: T): T {
  const hook = useCallback<any>(function (this: any, ...args: any[]) {
    return hook.fn.apply(this, args)
  }, [])
  hook.fn = fn
  return hook as T
}
